<template>
    <AvatarImage :url="gravatarUrl" />
</template>
<script setup>
    import AvatarImage from './AvatarImage.vue';
    import { onMounted, ref } from 'vue';
    import { sha256 } from '../utils/string.js';

    const props = defineProps({
        email: {
            type: String,
            default: null,
        },
    });

    const gravatarUrl = ref(null);

    onMounted(async () => {
        if (!props.email) {
            return null;
        }

        gravatarUrl.value = 'https://secure.gravatar.com/avatar/' + ((await sha256(props.email)) + '?d=404');
    });
</script>
